import { render } from "./forgetPasswordModal.vue?vue&type=template&id=69ef0495&scoped=true"
import script from "./forgetPasswordModal.vue?vue&type=script&lang=js"
export * from "./forgetPasswordModal.vue?vue&type=script&lang=js"

import "./forgetPasswordModal.vue?vue&type=style&index=0&id=69ef0495&lang=scss&scoped=true"

import exportComponent from "/home/forge/s.thebuyhive.com/expertsourcing/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69ef0495"]])

export default __exports__